// extracted by mini-css-extract-plugin
export default {"root":"PaidResultsTable_root__bnVh7","columnTitle":"PaidResultsTable_columnTitle__c6Hoa"};